import { RouterProvider, createBrowserRouter } from "react-router-dom";

import DefaultLayout from "containers/defaultLayout";
import NotFound from "pages/NotFound";
import Main from "pages/main";

import {goToLocation} from 'assets/js/commonUtil';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import GoogleTagManager from "components/common/GoogleTagManager";

function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <DefaultLayout />,
      errorElement: <NotFound />,
      children: [
        { index: true, element: <Main /> },
      ]
    },
  ]);
  return(
    <div className='App'>
      <GoogleTagManager gtmId="GTM-NMC482T7"></GoogleTagManager>
      <RouterProvider router={router} fallbackElement={<div>Loading...</div>} />
      <div className="btn-quick">
        <div className="btn-top top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src="https://img.chunhomall.com/images/brand_site/popup-icon-up_30x30.png.png" alt=""></img>
          <div>TOP</div>
        </div>
      </div>
    </div>
    
  );
}

export default App;
